import { useRouter } from '@tanstack/react-router';
import { FC } from 'react';

interface GoToReportProps {
    styles: {
        button?: string;
    };
    children: React.ReactNode;
    onClick?: () => void;
}

export const GoToBack: FC<GoToReportProps> = ({ styles, children, onClick }) => {
    const router = useRouter();

    const goBack = () => {
        if (onClick) {
            onClick();
        }
        router.history.back();
    };

    return (
        <button type="button" className={styles.button} onClick={goBack}>
            {children}
        </button>
    );
};
